<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="commercial-bottom-content">
            <div class="container">
                <div class="commercial-president-main-section cf">                   
                    <div  class="commercial-president-section cf" *ngFor="let hospitality of hospitalityList?.data">
                        <div  class="commercial-president-image-box"><img [src]="hospitality?.image"></div>
                        <div  class="commercial-president-content-box">
                           <div  class="titel-box">
                              <h2 class="titel-name">{{hospitality?.title}}</h2>
                           </div>
                           <div class="commercial-president-content" [innerHTML]="hospitality?.description">
                              
                           </div>
                           <div  class="commercial-president-btn" ><a  href="{{hospitality?.btn_url_1}}" *ngIf="hospitality?.btn_url_1"  target="_blank">{{hospitality?.btn_title_1}}</a>&nbsp; <a href="{{hospitality?.btn_url_2}}" *ngIf="hospitality?.btn_url_2" target="_blank">{{hospitality?.btn_title_2}}</a></div>
                          
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
       
    </div>
</section><!-- page ends-->